var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Scene } from "@babylonjs/core/scene";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Color4 } from "@babylonjs/core/Maths/math.color";
import { FreeCamera } from "@babylonjs/core/Cameras/freeCamera";
import { AdvancedDynamicTexture } from "@babylonjs/gui/2D/advancedDynamicTexture";
import { Rectangle } from "@babylonjs/gui/2D/controls/rectangle";
import { TextBlock } from "@babylonjs/gui/2D/controls/textBlock";
import { Control } from "@babylonjs/gui/2D/controls/control";
import { Button } from "@babylonjs/gui/2D/controls/button";
// import { InputText } from "@babylonjs/gui/2D/controls/inputText";
// import { InputPassword } from "@babylonjs/gui/2D/controls/inputPassword";
import { Image } from "@babylonjs/gui/2D/controls/image";
import State from "./Screens";
export class LoginScene {
    constructor() {
        this._loadedAssets = [];
        this._newState = State.NULL;
    }
    createScene(game) {
        return __awaiter(this, void 0, void 0, function* () {
            // app
            this._game = game;
            // create scene
            let scene = new Scene(this._game.engine);
            // set scene
            this._scene = scene;
            // set sky color
            this._scene.clearColor = new Color4(0.1, 0.1, 0.1, 1);
            //creates and positions a free camera
            let camera = new FreeCamera("camera1", new Vector3(0, 0, 0), this._scene);
            camera.setTarget(Vector3.Zero()); //targets the camera to scene origin
            // create ui
            const guiMenu = AdvancedDynamicTexture.CreateFullscreenUI("UI");
            this.create(guiMenu);
            // hide loading gui
            this._game.engine.hideLoadingUI();
        });
    }
    create(guiMenu) {
        // centered panel — fixed height so it sits in the middle of the screen
        const panel = new Rectangle("panel");
        panel.width = this._game.config.UI_SIDEBAR_WIDTH;
        panel.height = "280px";
        panel.background = "#000000";
        panel.thickness = 0;
        panel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        panel.verticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        guiMenu.addControl(panel);
        // logo
        const imgLogo = new Image("imgLogo", "./images/logo.svg");
        imgLogo.stretch = Image.STRETCH_UNIFORM;
        imgLogo.top = "0px";
        imgLogo.width = 1;
        imgLogo.height = "180px";
        imgLogo.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        panel.addControl(imgLogo);
        // version text
        const versionText = new TextBlock("versionText", this._game.config.version);
        versionText.width = 0.8;
        versionText.height = "28px";
        versionText.color = "#888888";
        versionText.top = "188px";
        versionText.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        versionText.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        panel.addControl(versionText);
        // // username input
        // const usernameInput = new InputText("usernameInput");
        // usernameInput.top = "-140px";
        // usernameInput.width = 0.8;
        // usernameInput.height = "30px;";
        // usernameInput.color = "#FFF";
        // usernameInput.text = "";
        // usernameInput.placeholderText = "Enter username";
        // usernameInput.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        // usernameInput.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        // panel.addControl(usernameInput);
        // usernameInput.onKeyboardEventProcessedObservable.add((ev) => {
        //     if (ev.key === "Tab") {
        //         guiMenu.focusedControl = passwordInput;
        //         ev.preventDefault();
        //     }
        // });
        // // password input
        // const passwordInput = new InputPassword("passwordInput");
        // passwordInput.width = 0.8;
        // passwordInput.height = "30px;";
        // passwordInput.color = "#FFF";
        // passwordInput.top = "-110px";
        // passwordInput.text = "";
        // passwordInput.placeholderText = "Enter password";
        // passwordInput.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        // passwordInput.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        // panel.addControl(passwordInput);
        // passwordInput.onKeyboardEventProcessedObservable.add((ev) => {
        //     if (ev.key === "Enter") {
        //         this.login(usernameInput.text, passwordInput.text);
        //         usernameInput.text = "";
        //         passwordInput.text = "";
        //     }
        // });
        // // login button
        // const joinBtn = Button.CreateSimpleButton("back", "Connect To Game");
        // joinBtn.width = 0.8;
        // joinBtn.height = "30px";
        // joinBtn.color = "white";
        // joinBtn.top = "-80px";
        // joinBtn.thickness = 1;
        // joinBtn.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        // joinBtn.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        // panel.addControl(joinBtn);
        // joinBtn.onPointerDownObservable.add(async () => {
        //     await this.login(usernameInput.text, passwordInput.text);
        //     usernameInput.text = "";
        //     passwordInput.text = "";
        // });
        // quick play button
        const joinGuestBtn = Button.CreateSimpleButton("joinGuestBtn", "Quick Play");
        joinGuestBtn.width = 0.8;
        joinGuestBtn.height = "40px";
        joinGuestBtn.color = "white";
        joinGuestBtn.thickness = 1;
        joinGuestBtn.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        joinGuestBtn.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        panel.addControl(joinGuestBtn);
        joinGuestBtn.onPointerDownObservable.add(() => __awaiter(this, void 0, void 0, function* () {
            this._game.setScene(State.CHARACTER_SELECTION);
        }));
        this._ui = guiMenu;
    }
}
